import { ITncRepository } from '../../ports/ITncRepository';
import { TncCase } from '../../domain/entities';

export class UpdateCaseDetailsUseCase {
  constructor(private readonly tncRepository: ITncRepository) {}

  async execute(caseId: string, details: Partial<TncCase['caseDetails']>): Promise<TncCase> {
    return this.tncRepository.updateCaseDetails(caseId, details);
  }
}
